import * as types from "../actionTypes";

export const getList = pageNumber => {
  return {
    type: types.PETTY_CASHIER_GET_LIST_MONTHLY_BUDGET_REQUEST,
    pageNumber: pageNumber
  };
};

export const getListSuccess = data => {
  return {
    type: types.PETTY_CASHIER_GET_LIST_MONTHLY_BUDGET_SUCCESS,
    payLoad: data
  };
};
export const getListFailure = error => {
  return {
    type: types.PETTY_CASHIER_GET_LIST_MONTHLY_BUDGET_FAILURE,
    error: error
  };
};

export const getInit = () => {
  return {
    type: types.PETTY_CASHIER_GET_INIT_MONTHLY_BUDGET_REQUEST
  };
};

export const getInitSuccess = data => {
  return {
    type: types.PETTY_CASHIER_GET_INIT_MONTHLY_BUDGET_SUCCESS,
    payLoad: data
  };
};
export const getInitFailure = error => {
  return {
    type: types.PETTY_CASHIER_GET_INIT_MONTHLY_BUDGET_FAILURE,
    error: error
  };
};

export const emptyCachedDataForCreate = () => {
  return {
    type: types.PETTY_CASHIER_EMPTY_MONTHLY_BUDGET_CACHED_DATA_FOR_CREATE
  };
};

export const store = data => {
  return {
    type: types.PETTY_CASHIER_STORE_MONTHLY_BUDGET_REQUEST,
    data: data
  };
};

export const storeSuccess = data => {
  return {
    type: types.PETTY_CASHIER_STORE_MONTHLY_BUDGET_SUCCESS,
    payLoad: data
  };
};
export const storeFailure = () => {
  return {
    type: types.PETTY_CASHIER_STORE_MONTHLY_BUDGET_FAILURE
  };
};

export const show = id => {
  return {
    type: types.PETTY_CASHIER_SHOW_MONTHLY_BUDGET_REQUEST,
    id: id
  };
};

export const showSuccess = data => {
  return {
    type: types.PETTY_CASHIER_SHOW_MONTHLY_BUDGET_SUCCESS,
    payLoad: data
  };
};
export const showFailure = error => {
  return {
    type: types.PETTY_CASHIER_SHOW_MONTHLY_BUDGET_FAILURE,
    error: error
  };
};

export const get = data => {
  return {
    type: types.PETTY_CASHIER_GET_MONTHLY_BUDGET_REQUEST,
    data: data
  };
};

export const getSuccess = data => {
  return {
    type: types.PETTY_CASHIER_GET_MONTHLY_BUDGET_SUCCESS,
    payLoad: data
  };
};
export const getFailure = error => {
  return {
    type: types.PETTY_CASHIER_GET_MONTHLY_BUDGET_FAILURE,
    error: error
  };
};

export const update = (id, data) => {
  return {
    type: types.PETTY_CASHIER_UPDATE_MONTHLY_BUDGET_REQUEST,
    id: id,
    data: data
  };
};

export const updateSuccess = data => {
  return {
    type: types.PETTY_CASHIER_UPDATE_MONTHLY_BUDGET_SUCCESS,
    payLoad: data
  };
};
export const updateFailure = () => {
  return {
    type: types.PETTY_CASHIER_UPDATE_MONTHLY_BUDGET_FAILURE
  };
};

export const remove = id => {
  return {
    type: types.PETTY_CASHIER_REMOVE_MONTHLY_BUDGET_REQUEST,
    id: id
  };
};

export const removeSuccess = data => {
  return {
    type: types.PETTY_CASHIER_REMOVE_MONTHLY_BUDGET_SUCCESS,
    payLoad: data
  };
};
export const removeFailure = () => {
  return {
    type: types.PETTY_CASHIER_REMOVE_MONTHLY_BUDGET_FAILURE
  };
};
